import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-white text-slate-900 pt-0 pb-8 px-4 md:pt-4 md:pb-16 overflow-hidden relative" data-id="element-156">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-157">
        <div className="animate-fadeInUp" data-id="element-158">
          <div className="inline-block bg-brand-primary/10 text-brand-primary px-4 py-1.5 rounded-full text-[10px] font-bold mb-2 border border-brand-primary/20 tracking-widest uppercase mt-4" data-id="element-159">
            ✨ SISTEMA PROFESIONAL PARA ESTILISTAS, PELUQUERAS Y DUEÑAS DE SALÓN
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-extrabold mb-1 px-0 text-slate-900 uppercase text-[20px]" data-id="element-160">
            💥 DEJÁ DE IMPROVISAR EN TU PELUQUERÍA Y EMPEZÁ A{' '}
            <span className="bg-gradient-to-r from-brand-primary via-brand-primaryLight to-brand-primary bg-clip-text text-transparent" data-id="element-161">
              TRABAJAR CON ESTRUCTURA PROFESIONAL.
            </span>
          </h1>

          <div className="relative mb-0 max-w-2xl mx-auto" data-id="element-162">
            <div className="absolute inset-0 bg-brand-primary/5 blur-[100px] rounded-full scale-75 pointer-events-none" data-id="element-163" />
            <img src="https://cdn.magicpatterns.com/uploads/f3mdkUQPLoA4EHusbTnVEV/MOCKUP1_600x.png" alt="MegaPack Peluquería Lista Mockup" className="w-full h-auto relative z-10 mockup-glow" fetchPriority="high" data-id="element-164" />
          </div>

          <p className="md:text-xl font-medium mb-6 max-w-2xl mx-auto text-slate-600 text-[15px] leading-relaxed" data-id="element-165">
            Todo listo para usar. Sistema profesional organizado y listo para
            aplicar desde hoy.
          </p>

          <CTAButton text="QUIERO ACCESO INMEDIATO" className="w-auto mx-auto mb-8 shadow-xl shadow-brand-primary/20" data-id="element-166" />

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs md:text-sm text-slate-400 font-medium" data-id="element-167">
            <div className="flex items-center gap-2" data-id="element-168">
              <ShieldCheck size={18} className="text-brand-primary" data-id="element-169" />
              <span data-id="element-170">Garantía 7 días </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-171">
              <Lock size={18} className="text-brand-primary" data-id="element-172" />
              <span data-id="element-173">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-174">
              <CreditCard size={18} className="text-brand-primary" data-id="element-175" />
              <span data-id="element-176">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}